import { ErrorResponse } from "@app/core/models";
import { RelationRelationCreateModel } from "@app/modules/relation-relation/models/relation-relation-create.model";
import { RelationRelationTableItemModel } from "@app/modules/relation-relation/models/relation-relation-table.model";
import { TableDataModel } from "@app/shared/models";
import { KeyValueModel } from "@app/shared/models/common/key-value.model";
import { TableFilterModel } from "@app/shared/models/table/table-filter.model";
import { TableSortingModel } from "@app/shared/models/table/table-sorting.model";
import { createAction, props } from "@ngrx/store";

export const GetOverview = createAction("[RelationRelation] GetOverview");
export const GetOverviewError = createAction("[RelationRelation] GetOverviewError", props<{ response: ErrorResponse }>());
export const GetOverviewSuccess = createAction("[RelationRelation] GetOverviewSuccess", props<TableDataModel<RelationRelationTableItemModel>>());

export const FilterOverview = createAction("[RelationRelation] FilterOverview", props<{filter?: TableFilterModel[], thenBy?: TableSortingModel[], relationId: number, sorting?: TableSortingModel, pagination: { page: number, pageSize: number }}>());

export const ResetOverview = createAction("[RelationRelation] ResetOverview");
export const ResetCreate = createAction("[RelationRelation] ResetCreate");

export const Create = createAction("[RelationRelation] Create", props<RelationRelationCreateModel>());
export const CreateError = createAction("[RelationRelation] CreateError", props<{ response: ErrorResponse }>());
export const CreateSuccess = createAction("[RelationRelation] CreateSuccess", props<RelationRelationCreateModel>());

export const GetRelations = createAction('[RelationRelation] GetRelations',props<{ searchQuery: string; skipCount: number }>(),);
export const GetRelationsError = createAction('[RelationRelation] GetRelationsError', props<{ response: ErrorResponse }>());
export const GetRelationsSuccess = createAction('[RelationRelation] GetRelationsSuccess',props<{ relations: KeyValueModel[] }>(),);

export const Delete = createAction("[RelationRelation] Delete", props<{ id: number }>());
export const DeleteError = createAction("[RelationRelation] DeleteError", props<{ response: ErrorResponse }>());
export const DeleteSuccess = createAction("[RelationRelation] DeleteSuccess");